/** @format */

import { SubscriptionFrequencyEnum } from '@shared/data-access/enums';

export interface SubscriptionSettings {
  emailSubscription: SubscriptionFrequencyEnum;
  mailSubscription: SubscriptionFrequencyEnum;
  textSubscription: SubscriptionFrequencyEnum;
}
